import { useState } from 'react'
import { Button } from 'react-bootstrap'
import { FaChevronDown } from 'react-icons/fa'
import TextTruncate from 'react-text-truncate'
import cn from 'classnames'
import s from './TruncatedCommentaire.module.scss'

interface Props {
  commentaire: string | null
  className?: string
}

const defaultProps = {
  className: undefined,
}

const TruncatedCommentaire = ({
  commentaire,
  className,
}: Props): JSX.Element | null => {
  // Is set to false if button 'see more' is not needed
  const [truncated, setTruncated] = useState(false)
  const [show, setShow] = useState(false)

  return (
    (commentaire && (
      <p className={cn(s.comment, className)}>
        <b>Commentaire :</b>
        <TextTruncate
          line={!show && 2}
          element="span"
          truncateText="…"
          text={commentaire}
          onToggled={setTruncated}
          textTruncateChild={
            <Button
              className={cn(s.btnExpand, { [s.rotate]: show })}
              variant="link"
              onClick={() => setShow(!show)}
            >
              Lire plus...
              <FaChevronDown />
            </Button>
          }
        />
        {truncated && show && (
          <Button
            className={cn(s.btnExpand, { [s.rotate]: show })}
            variant="link"
            onClick={() => setShow(!show)}
          >
            Lire moins...
            <FaChevronDown />
          </Button>
        )}
      </p>
    )) ||
    null
  )
}

TruncatedCommentaire.defaultProps = defaultProps
export default TruncatedCommentaire
